<template>
  <div
    class="d-lg-none">
    <!-- フッター -->
    <mobile-footer />
  </div>
</template>

<script>
import MobileFooter from '@/components/parts/MobileFooter.vue'

export default {
  components: {
    MobileFooter,
  },
}
</script>

<style>

</style>